import React from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	inView?: boolean
	ref?: React.LegacyRef<HTMLDivElement>
}

const ViewWrapper: React.FC<Props> = ({ children, inView = true }) => {
	return (
		<div>
			{inView && children}
			{/* <ButtonsSupport /> */}
		</div>
	)
}

export default ViewWrapper
